import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import OrderListVendor from 'components/layout/vendorOrder/OrderListVendor';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';

import may from 'js/security';

class VendorOrders extends React.Component {
  render() {
    const {
      intl: { messages },
      user,

    } = this.props;

    return (
      <DocMeta tags={generateMetaTags(messages.meta.orders)}>
        <OrderListVendor />
      </DocMeta>
    );
  }
}
VendorOrders.defaultProps = {

};

const mapStateToProps = state => {
  return {
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(VendorOrders));
